/* eslint-disable promise/param-names */
import {
  BOOKS_REQUEST,
  BOOK_GET_NEW_ID,
  BOOK_UPLOAD_FILE,
  BOOK_UPLOAD_FILE_BASE_64,
  BOOKS_REQUEST_BY_ID,
  BOOK_SAVE,
  BOOK_DELETE,
  BOOKS_REPLACE,
  BOOKS_SUCCESS
} from '@/store/actions/books';

import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/storage';

import querystring from 'querystring-browser';
import moment from 'moment';

import Vue from 'vue';
import {sleep} from '@/utils/utils.js'

const storageBaseLink = process.env.VUE_APP_STORAGE_BASE_LINK

const state = { 
  books: [],
  status: '',
  hasLoadedOnce: false,
};

const getters = {
  books: state => state.books ? state.books : [],
  booksLoading: state => state.status == 'loading',
  booksLoaded: state => { 
    return state.hasLoadedOnce
  }
};

const actions = {
  [BOOKS_REQUEST]: ({commit}) => {
    if (state.hasLoadedOnce) {
      return;
    }

    return new Promise((resolve) => {
      commit(BOOKS_REQUEST)

      firebase.firestore().collection('books').orderBy('created_at')
        .onSnapshot(querySnapshot => {
          let books = []

          querySnapshot.docChanges().forEach(change => {
            books.push(change.doc.data())
          })

          if (state.hasLoadedOnce == false) {
            commit(BOOKS_SUCCESS, books)
          } else {

            commit(BOOKS_REPLACE, books)
          }

          resolve();
        })
    })
  },

  [BOOK_DELETE]: ({commit}, book) => {
    return new Promise(async (resolve, reject) => {
      commit(BOOKS_REQUEST)

      await firebase.firestore()
          .collection('books').doc(String(book.id)).delete()
              .then(() => {
                commit(BOOK_DELETE, book.id)
                resolve()
              })
              .catch(err => {
                reject(err)
              })
    })
  },

  [BOOK_SAVE]: ({commit}, book) => {
    /**
     * Handle date
     */
    book.created_at = new Date(moment(book.created_at))
    book.updated_at = new Date()
    book.publication_date = new Date(moment(book.publication_date))

    return new Promise(async (resolve, reject) => {
      commit(BOOKS_REQUEST)

      /**
       * handle publishers
       */
      if (book.publisher.id == undefined) {
        await firebase.firestore()
          .collection('publishers')
              .add(book.publisher).then(res => {
                firebase.firestore().collection('publishers').doc(String(res.id)).update({id: res.id})
                    .then(()=>{
                      book.publisher.id = res.id
                      firebase.firestore().collection('books').doc(String(book.id)).set(book)
                        .then(response => {
                          resolve(response)
                        })
                        .catch(err => {
                          reject(err)
                        })
                    })
                    .catch(err => {
                      console.log(err)
                    })
              })
              .catch(err => {
                console.log(`add book.publisher error ${err}`)
              })
      } else {
        await firebase.firestore().collection('books').doc(String(book.id)).set(book)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            console.log(`add book error ${err}`)
            reject(err)
          })
      }
    })
  },

  [BOOKS_REQUEST_BY_ID]: ({commit}, bookId) => {

    return new Promise(async (resolve, reject) => {
      if (!state.hasLoadedOnce) {
        while (state.status === 'loading') {
          await sleep(300)
        }
        //Stringify to awoid mutation error
        let book = JSON.parse(JSON.stringify(state.books.find(elem => elem.id == bookId)))

        if (book != undefined) {
          book.files.forEach(file => {
            file.url = storageBaseLink.replace('[URL]', querystring.escape(file.fullPath))
          })
          commit(BOOKS_SUCCESS)

          //Handle book timestamps before return to user
          book.created_at = new Date(book.created_at.seconds * 1000)
          book.updated_at = new Date(book.updated_at.seconds * 1000)

          if (book.publication_date != null) {
            book.publication_date = new Date(book.publication_date.seconds * 1000)
          }

          resolve(book)
        } else {
          reject('not found')
        }
      } else {
        let book = JSON.parse(JSON.stringify(state.books.find(elem => elem.id == bookId)))

        if (book != undefined) {
          book.files.forEach(file => {
            file.url = storageBaseLink.replace('[URL]', querystring.escape(file.fullPath))
          })
          commit(BOOKS_SUCCESS)

          /**
           * Handle book timestamps before return to user
           */
          book.created_at = new Date(book.created_at.seconds * 1000)
          book.updated_at = new Date(book.updated_at.seconds * 1000)

          if (book.publication_date != null) {
            book.publication_date = new Date(book.publication_date.seconds * 1000)
          }

          resolve(book)
        }

        reject('not found')
      }
    })
  },

  [BOOK_GET_NEW_ID]: ({commit}) => {
    return new Promise( (resolve, reject) => {
      var getNewBookId = firebase.functions().httpsCallable('getNewBookId');
      getNewBookId().then(result => {
        commit(BOOKS_SUCCESS)
        resolve(result.data)
      }).catch(err => {
        reject(err)
      })
    });
  },
  [BOOK_UPLOAD_FILE]: ({commit}, args) => {
    var storageRef = firebase.storage().ref()

    return new Promise( (resolve, reject) => {
      storageRef.child('images/' + args.bookId + '/' + args.file.name).put(args.file)
        .then(snapshot => {
          commit(BOOKS_SUCCESS)
          resolve({
            fullPath: snapshot.metadata.fullPath,
            name: snapshot.metadata.name,
            size: snapshot.metadata.size,
            contentType: snapshot.metadata.contentType,
            timeCreated: snapshot.metadata.timeCreated,
            url: storageBaseLink.replace('[URL]', querystring.escape(snapshot.metadata.fullPath))
          })
        })
        .catch(err =>{
          reject(err)
        })
    });
  },

  [BOOK_UPLOAD_FILE_BASE_64]: ({commit}, args) => {
    var storageRef = firebase.storage().ref()

    return new Promise( (resolve, reject) => {
      storageRef.child('images/' + args.bookId + '/' + args.file.name).putString(args.file.dataUrl, 'data_url')
          .then(function(snapshot) {
            commit(BOOKS_SUCCESS)
            resolve({
              fullPath: snapshot.metadata.fullPath,
              name: snapshot.metadata.name,
              size: snapshot.metadata.size,
              contentType: snapshot.metadata.contentType,
              timeCreated: snapshot.metadata.timeCreated,
              url: storageBaseLink.replace('[URL]', querystring.escape(snapshot.metadata.fullPath))
            })
          })
          .catch(err =>{
            reject(err)
          });
    });
  },
}

const mutations = {
  [BOOKS_REQUEST]: (state) => {
    state.status = 'loading';
  },

  [BOOKS_SUCCESS]: (state, books) => {
    state.status = 'success'

    if (books != undefined) {
      state.books = books
      state.hasLoadedOnce = true
    }
  },

  [BOOK_DELETE]: (state, bookId) => {
    let rowIndex = state.books.findIndex(elem => elem.id == bookId)

    if (rowIndex != -1) {
      state.books.splice(rowIndex, 1)
    }
  },

  [BOOKS_REPLACE]: (state, books) => {
    books.forEach(book => {
      let rowIndex = state.books.findIndex(elem => elem.id == book.id)
      if (rowIndex != -1) {
        Vue.set(state.books, rowIndex, book)
      } else {
        state.books.push(book)
      }
    })
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
}
